import { Component, ElementRef, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { BreadCrumb } from '../../model/breadcrumb';
import { BreadcrumbLabels } from '@shared/enums/breadcrumb-labels.enum';
import { BreadcrumbIcons } from '@shared/enums/breadcrumb-icons.enum';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnDestroy {
  @Input() set bgColor(value: string) {
    this.elementRef.nativeElement?.style.setProperty('--background-color', value);
  }

  breadcrumbs: BreadCrumb[] = [];
  showBreadcrumb = true;

  readonly BreadcrumbLabels = BreadcrumbLabels;
  readonly BreadcrumbIcons = BreadcrumbIcons;
  private breadcrumbSubscription: Subscription;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.breadcrumbSubscription = this.breadcrumbService.breadcrumbList$.subscribe(
      (breadcrumbList) => {
        this.breadcrumbs = breadcrumbList.map((crumb) => {
          return new BreadCrumb(crumb.labelKey, crumb['url'], crumb.isValue, crumb.isActive);
        });
        this.updateBreadcrumbs();
      }
    );

    this.showBreadcrumb = this.breadcrumbService.visibility$.value;
    this.breadcrumbService.visibility$.subscribe((value) => (this.showBreadcrumb = value));
  }
  private updateBreadcrumbs(): void {
    const url = this.router.url;
    const id = this.route.snapshot.paramMap.get('id');
    if (
      (url.includes('shipments/b2b/all/view') || url.includes('shipments/b2b/my-shipments/view')) &&
      id
    ) {
      const lastIndex = this.breadcrumbs.length - 1;
      if (lastIndex >= 0) {
        this.breadcrumbs[lastIndex].labelKey = `${id}`;
        this.breadcrumbs[lastIndex].isValue = true;
      }
    }
  }

  ngOnDestroy(): void {
    if (this.breadcrumbSubscription) {
      this.breadcrumbSubscription.unsubscribe();
    }
  }
}
